<template>
  <div
    class="flex flex-col gap-3 pt-2 sm:max-w-2xl sm:mx-auto"
  >
    <div v-if="loggedIn" class="pt-3 px-1 flex flex-col items-center gap-2">
      <h2>{{ $t('spotdetail.comments_title') }}</h2>
      <CommentAdd
        :user="user"
        :spot="spot"
      />
    </div>
    <div v-else
         class="my-2 py-2 px-1 flex flex-col items-center gap-2 border border-dashed border-theme-secondary text-theme-primary hover:text-theme-secondary">
      <NuxtLink href="/login">{{ $t('spotdetail.comments_discuss_title') }}</NuxtLink>
    </div>
    <TransitionGroup>
      <CommentListElement
        v-for="comment of spot.comments"
        :comment="comment"
        :spot="spot"
        :key="comment.id"
      />
    </TransitionGroup>
  </div>
</template>
<script setup lang="ts">
const props = defineProps<{ spot: SpotDetail }>();
const {loggedIn,user } = useUserSession();

</script>
<style lang="scss" scoped>
.v-enter-from {
  opacity: 0;
}
.v-enter-to {
  opacity: 1;
}
.v-enter-active {
  transition: opacity 0.2s;
}
</style>
